import { TAddon, TDuration } from 'common/cms-types'
import { planSummaryStrings } from 'common/strings/plan-summary-strings'
import { GA4AddToCart } from '../../types/global'
import { getTenantCurrency } from 'common/tenant'

const getPriceId = (
  pricing: { month_price_id: string; year_price_id: string },
  duration: TDuration,
) => {
  return duration === 'month' ? pricing.month_price_id : pricing.year_price_id
}

export const addonToEvent = (
  data: TAddon,
  duration: TDuration,
  buttonType?: string,
  quantity?: number,
) => {
  const qty = quantity || 1
  const price = data.pricing
    ? (duration === 'month'
        ? data.pricing.month_price
        : data.pricing.year_price) / 100
    : 0
  return {
    currency: getTenantCurrency(),
    items: [
      {
        currency: getTenantCurrency(),
        // Callers can pass a bare `{ slug, isService }` stub (e.g. removing a
        // business service from the checkout summary), which has no pricing.
        item_id:
          (data.pricing && getPriceId(data.pricing, duration)) || data.slug,
        item_name: `${
          planSummaryStrings[data.title] || data.title
        } ${duration}`,
        price: price.toFixed(2),
        quantity: qty,
      },
    ],
    value: (price * qty).toFixed(2),
    ...(buttonType && { button_type: buttonType }),
  } as GA4AddToCart
}

export const directorToEvent = (
  duration: TDuration,
  dsaAddon?: TAddon,
  quantity = 1,
) => {
  const price = dsaAddon?.pricing
    ? (duration === 'month'
        ? dsaAddon.pricing.month_price
        : dsaAddon.pricing.year_price) / 100
    : 0
  const itemId = dsaAddon?.pricing
    ? duration === 'month'
      ? dsaAddon.pricing.month_price_id
      : dsaAddon.pricing.year_price_id
    : 'director-service-address-addon'
  return {
    currency: getTenantCurrency(),
    items: [
      {
        currency: getTenantCurrency(),
        item_id: itemId,
        item_name: `${planSummaryStrings.directorsServiceAddress} ${duration}`,
        price: price.toFixed(2),
        quantity,
      },
    ],
    value: (price * quantity).toFixed(2),
  } as GA4AddToCart
}
